export default __webpack_public_path__ + "static/media/gps.e7efff20.svg";